import React from 'react';
import { useLazyModals } from 'src/components/SignIn/LazyModals';

import { Button } from '../Button/Button';

import classes from './Login.scss';

type Props = Record<string, unknown>;

export const CustomisationLogin: React.FC<Props> = () => {
    const { components, dispatch } = useLazyModals();
    return (
        <>
            <div className={classes.login}>
                <div className={classes.loginContent}>
                    <h4 className={classes.loginTitle}>Returning Customer?</h4>
                    <p className={classes.loginDesc}>Log in to access your previous logos</p>
                </div>
                <div className={classes.loginAction}>
                    <Button
                        variant="light"
                        onClick={() => dispatch({ kind: 'sign-in' })}
                        data-test-id="CustomisationLogin"
                    >
                        Log In
                    </Button>
                </div>
            </div>
            {components}
        </>
    );
};
